import { useEffect, useState } from 'react';

export interface Category {
  id: string;
  label: string;
}

export interface Project {
  id: string;
  title: string;
  category: string;
  description?: string;
  year?: number;
  thumbnail: string;
  images?: string[];
}

export interface ProjectsData {
  categories: Category[];
  projects: Project[];
}

/** "Show all" pseudo-filter id used by the category filter. */
export const ALL_CATEGORY = 'all';

/**
 * Loads public/img/projects.json. Kept here so the presentational components
 * (CategoryFilter, ProjectGrid, ProjectCard) stay free of data fetching.
 */
export function useProjects() {
  const [data, setData] = useState<ProjectsData | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    // Absolute path, matching the app's existing "/img/..." asset convention.
    fetch('/img/projects.json')
      .then((res) => {
        if (!res.ok) throw new Error(`projects.json: ${res.status}`);
        return res.json();
      })
      .then((json: ProjectsData) => active && setData(json))
      .catch((err: Error) => active && setError(err));
    return () => {
      active = false;
    };
  }, []);

  return { data, error, loading: !data && !error };
}
